

jQuery(function($) {

	$(function(){

		/*
		* Load More
		*/
		$('#explore_loadmore').click(function(event){

			event.preventDefault();
			console.log('loadmore');

			$.ajax({
				url : explore_loadmore_params.ajaxurl, // AJAX handler
				data : {
					'action': 'exploreloadmore', // the parameter for admin-ajax.php
					'query': explore_loadmore_params.posts, // loop parameters passed by wp_localize_script()
					'page' : explore_loadmore_params.current_page // current page
				},
				type : 'POST',
				beforeSend : function ( xhr ) {
					$('#explore_loadmore').text('Loading...'); // some type of preloader
				},
				success : function( posts ){
					if( posts ) {

						// console.log(posts);

						// $('.postpage__wrapper').empty();
						$('#recipes_loadmore').text( 'Load More' );
						$('#postpage__results').append( posts ); // insert new posts
						explore_loadmore_params.current_page++;

						if ( explore_loadmore_params.current_page == explore_loadmore_params.max_page ){
							$('.postpage__loadmore').hide(); // if last page, HIDE the button
						}

					} else {
						$('.postpage__loadmore').hide(); // if no data, HIDE the button as well
					}
				}
			});
			return false;
		});

		/*
		* Filter
		*/
		$('#filter_explore').submit(function(event){

			event.preventDefault();
			console.log('filter');

			$.ajax({
				url : explore_loadmore_params.ajaxurl,
				data : $('#filter_explore').serialize(), // form data
				dataType : 'json', // this data type allows us to receive objects from the server
				type : 'POST',
				beforeSend : function(xhr){
					// $('#filter_explore').find('button').text('Filtering...');
				},
				success : function( data ){

					console.log(data.content);

					$('.postpage__list').empty();

					// when filter applied:
					// set the current page to 1
					explore_loadmore_params.current_page = 1;

					// set the new query parameters
					explore_loadmore_params.posts = data.posts;

					// set the new max page parameter
					explore_loadmore_params.max_page = data.max_page;

					// change the button label back
					// $('#filter_recipes').find('button').text('Apply filter');

					// insert the posts to the container
					// $('#postpage__results .row').html(data.content);
					$('#postpage__results').html(data.content);

					// console.log(data.content);
					// console.log(data);

					// hide load more button, if there are not enough posts for the second page
					if ( data.max_page < 2 ) {
						$('.postpage__loadmore').hide();
					} else {
						$('.postpage__loadmore').show();
					}
				}
			});

			// do not submit the form
			return false;

		});

	});

});